import React from 'react';
import styled from 'styled-components';

import { TOGGLE_ICON_SIZE } from '@front/common/src/components/accordion/constants';

import { translate } from '@front/i18n';

import Skeleton from '@front/web-ui/src/components/skeleton/skeleton';
import Text from '@front/web-ui/src/components/base-text/variants/text';

const t = translate('basket.cleaning.services');

const StyledSubtitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  margin-right: ${15 + TOGGLE_ICON_SIZE}px;
`;

type AccordionSubtitleProps = {
  formattedPrice?: string;
  hasTaxCredit?: boolean;
  isLoading: boolean;
};

const AccordionSubtitle = ({ formattedPrice, hasTaxCredit, isLoading }: AccordionSubtitleProps) => {
  if (isLoading)
    return (
      <StyledSubtitle>
        <Skeleton linesWidth={['70px', '70px']} />
      </StyledSubtitle>
    );

  if (hasTaxCredit)
    return (
      <StyledSubtitle>
        <Text>{`${t('base.or')} ${formattedPrice}`}</Text>
        <Text.SM>{`\xa0${t('.accordion_subtitle')}`}</Text.SM>
      </StyledSubtitle>
    );

  return undefined;
};

export default AccordionSubtitle;
